module.exports = __webpack_public_path__ + "img/logo_quartier-libre.2cfa14f4.png";